// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as LumiDate from "lumi-rescript/lib/es6/src/LumiDate.res.js";
import * as LumiJzon from "lumi-rescript/lib/es6/src/LumiJzon.res.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";

let jsonCodec = LumiJzon.taggedVariantOptionalContents(mode => {
  if (typeof mode !== "object") {
    if (mode === "DisableUploading") {
      return [
        "DisableUploading",
        undefined
      ];
    } else {
      return [
        "UploadSamplesAutomatic",
        undefined
      ];
    }
  } else {
    return [
      "UploadSamplesMonthly",
      Jzon.encodeWith(mode._0, Jzon.int)
    ];
  }
}, pair => {
  let other = pair[0];
  switch (other) {
    case "DisableUploading" :
      return {
        TAG: "Ok",
        _0: "DisableUploading"
      };
    case "UploadSamplesAutomatic" :
      return {
        TAG: "Ok",
        _0: "UploadSamplesAutomatic"
      };
    case "UploadSamplesMonthly" :
      let json = pair[1];
      if (json !== undefined) {
        return Stdlib_Result.map(Jzon.decodeWith(json, Jzon.int), samplesPerMonth => ({
          TAG: "UploadSamplesMonthly",
          _0: samplesPerMonth
        }));
      } else {
        return {
          TAG: "Error",
          _0: {
            NAME: "UnexpectedJsonValue",
            VAL: [
              [],
              other
            ]
          }
        };
      }
    default:
      return {
        TAG: "Error",
        _0: {
          NAME: "UnexpectedJsonValue",
          VAL: [
            [],
            other
          ]
        }
      };
  }
}, undefined, undefined);

let SampleUploadMode = {
  jsonCodec: jsonCodec
};

let jsonCodec$1 = Jzon.object4(param => [
  param.beginTime,
  param.endTime,
  param.interval,
  param.dataSet
], param => ({
  TAG: "Ok",
  _0: {
    beginTime: param[0],
    endTime: param[1],
    interval: param[2],
    dataSet: param[3]
  }
}), Jzon.field("beginTime", LumiDate.DateTime.jsonCodec), Jzon.field("endTime", LumiDate.DateTime.jsonCodec), Jzon.field("interval", LumiDate.Duration.JsonCodecs.seconds), Jzon.field("dataSet", Jzon.string));

let ImageSequenceSpec = {
  jsonCodec: jsonCodec$1
};

let jsonCodec$2 = Jzon.object3(param => [
  param.facilityLabel,
  param.sampleUploadMode,
  param.sampleDataSet
], param => ({
  TAG: "Ok",
  _0: {
    facilityLabel: param[0],
    sampleUploadMode: param[1],
    sampleDataSet: param[2]
  }
}), Jzon.field("facilityLabel", Jzon.string), Jzon.field("sampleUploadMode", jsonCodec), Jzon.field("sampleDataSet", Jzon.string));

let TrainingDataSpec = {
  jsonCodec: jsonCodec$2
};

export {
  SampleUploadMode,
  ImageSequenceSpec,
  TrainingDataSpec,
}
/* jsonCodec Not a pure module */
